/// <amd-module name="Wit/LinkedWorkItemsDropdown/Components/LinkedWorkItemsCommitDetails" />
import * as React from "react";
import { onClickFPS } from "VSS/Platform/FPS";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { ReadyableArrayObserver } from "VSSUI/Observer";
import { ITableRow } from "VSSUI/Table";
import * as Resources from "Wit/LinkedWorkItemsDropdown/Resources";
import { getLinkedWorkItemsCommitDetailViewService } from "../LinkedWorkItemsCommitDetailViewService";
import { IWorkItemEntry } from "../Util/Data";
import { LinkedWorkItemsTable } from "./LinkedWorkItemsTable";

interface GitRepository {
    id: string;
    project: { id: string };
}

interface ILinkedWorkItemsCommitDetailsProps {
    commitId: string;
    repository: GitRepository;
}

export class LinkedWorkItemsCommitDetails extends VssComponent<ILinkedWorkItemsCommitDetailsProps> {
    public render() {
        const { commitId, repository } = this.props;
        const viewService = getLinkedWorkItemsCommitDetailViewService(this.context.pageContext);

        return (
            <div className="flex-column rhythm-vertical-8">
                <ReadyableArrayObserver
                    data={viewService.getLinkedWorkItems(repository.project.id, repository.id, commitId)}
                    dataComponent={this.renderDataComponent}
                />
            </div>
        );
    }

    private renderDataComponent = () => {
        const { commitId, repository } = this.props;
        const viewService = getLinkedWorkItemsCommitDetailViewService(this.context.pageContext);

        return (
            <Card className="bolt-table-card" titleProps={{ text: Resources.WorkItems }}>
                <LinkedWorkItemsTable
                    expanded={true}
                    itemProvider={viewService.getLinkedWorkItems(repository.project.id, repository.id, commitId)}
                    onActivate={(event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<IWorkItemEntry>) => {
                        if (!event.defaultPrevented) {
                            onClickFPS(this.context.pageContext, tableRow.data.href!, true, event);
                        }
                    }}
                />
            </Card>
        );
    };
}
Components.add("WIT.LinkedWorkItemsCommitDetails", LinkedWorkItemsCommitDetails);
